module.exports = __webpack_public_path__ + "static/ss12.88ec6ab1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo/ss12.png
// module id = 527
// module chunks = 35783957827783